import { render } from "./BbScoreBar.vue?vue&type=template&id=6dab7aa8&scoped=true"
import script from "./BbScoreBar.vue?vue&type=script&lang=js"
export * from "./BbScoreBar.vue?vue&type=script&lang=js"

import "./BbScoreBar.vue?vue&type=style&index=0&id=6dab7aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dab7aa8"]])

export default __exports__